/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Plh_IntroInputs */

const vi_pl_plh_intro = /** @type {(inputs: Pl_Plh_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi lại các lô đã khiêng ra khỏi kho chè mua để đưa vào phân loại. Phiếu không trừ tồn kho.`)
};

/**

* @param {Pl_Plh_IntroInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_plh_intro = /** @type {((inputs?: Pl_Plh_IntroInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Plh_IntroInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_plh_intro(inputs)
});